import axios from "axios";
import Cookie from 'js-cookie'

const request = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000,
    withCredentials: false, // 跨域请求的时候是否需要凭证
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    },
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        let contentType = config.headers['Content-Type'];
        if(contentType){
            config.headers['Content-Type']= contentType
        }
        // console.log(config.method, config.url, config.data, 'config')
        // if(config.url == 'phoneCallLog/excelExport'){
        //     request.defaults.responseType = 'blob'
        // }

        let token =  Cookie.get('token') ? Cookie.get('token') : null
        // let token =  Cookie.get('token_web') ? Cookie.get('token_web') : null
        if (token) {
            config.headers['TOKEN'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers['TOKEN_TYPE'] = "web"
        return config;
    },
    error => {
        return Promise.reject(error); // 请求错误处理
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        // console.log(response, 'axios lanjie') // 这里查询鉴权功能
        // if (response.data.errno === 999) {
        //     this.$router.push('/login')
        //     console.log("token过期");
        // }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Cookie.set('token', '');
                    Cookie.set('userinfo', '');
                    if (window.vm && window.vm.$refs.login) {
                        window.vm.$refs.login.show()
                    }
                    break;
                case 404:
                    console.log('Resource not found');
                    break;
                case 500:
                    console.log('There is a server problem');
                    break;
                default:
                    console.log('There is an error');
                    console.log(error);
            }
        }
        return Promise.reject(error);
    }
);

export default request
